import { type JSX, Match, Switch } from "solid-js";
import { Skeleton } from "@/components/ui/skeleton";
import { useVault } from "../vault-context";
import { VaultSetup } from "./vault-setup";
import { VaultUnlock } from "./vault-unlock";

/**
 * Compuerta del vault: muestra setup / unlock / contenido según el estado.
 * El contenido (`children`) solo se renderiza cuando el vault está desbloqueado,
 * garantizando que las claves están en memoria antes de descifrar nada.
 */
export function VaultGate(props: { children: JSX.Element }) {
  const vault = useVault();
  return (
    <Switch>
      <Match when={vault.status() === "loading"}>
        <div class="mx-auto flex max-w-2xl flex-col gap-3 px-4 py-10">
          <Skeleton class="h-8 w-40" />
          <Skeleton class="h-16 w-full" />
          <Skeleton class="h-16 w-full" />
        </div>
      </Match>
      <Match when={vault.status() === "needs-setup"}>
        <VaultSetup />
      </Match>
      <Match when={vault.status() === "locked"}>
        <VaultUnlock />
      </Match>
      <Match when={vault.status() === "unlocked"}>{props.children}</Match>
    </Switch>
  );
}
